import Siema from 'siema'

const Slider = () => {
  const sliders = {}
  ;[...document.querySelectorAll('.js-slider')].forEach(slider => {
    const {id} = slider
    let indexElement = document.querySelector(`.js-slider-index#${id}`)

    sliders[id] = {
      slider: new Siema({
        selector: `#${id}`,
        loop: true,
        duration: 500,
        onChange: goChange,
        onInit: printSlideIndex
      }),
      animateChildren: []
    }

    // Add children to animate in an array based on slider-item index
    const items = document.getElementById(id).querySelectorAll('.c-slider-item')
    ;[...items].forEach((item, i) => {
      const animations = item.querySelectorAll('.js-slider-animation')
      sliders[id].animateChildren[i] = animations
    })

    function printSlideIndex() {
      indexElement.innerHTML = this.currentSlide + 1
    }

    function goChange() {
      indexElement.innerHTML = this.currentSlide + 1 //printSlideIndex

      const { currentSlide } = sliders[id].slider
      const animatedContent = [].slice.call(sliders[id].animateChildren[currentSlide])
      animatedContent.forEach(animate => animate.classList.add('active'))
    }

  })

  ;[...document.querySelectorAll('.js-slider-nav')].forEach(button => {
    button.style.opacity = 1
    button.addEventListener('click', function (e) {
      e.preventDefault()
      const {target, direction} = this.dataset
      if (direction === 'prev') sliders[target].slider.prev()
      if (direction === 'next') sliders[target].slider.next()
    })
  })
}

export default Slider



// WEBPACK FOOTER //
// ./src/js/modules/Slider.js